import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// import axios from "axios";
import "./Verify.css";
import i18n from "./../../i18n";
import { getApiData } from "./../../api/api";
import Error from "./../Error/Error";
import { showLoader } from "./../../redux/actions/action_loader";
import { withTranslation } from "react-i18next";
import { androidUrl, desktopUrl, getDevice, getDeviceBrowserInfo, getDeviceInfo, iosUrl, isIOSDevice, validBrowser, validBrowserForNewUi } from "../../utils/getDevice";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import LanguageSelect from "./LanguageSelect/LanguageSelect";
import Introduction from "../Introduction/Introduction";
import { handleVoice, handleVoiceOverLang, stopVoiceOver, hindiVoiceOverDisclaimer, englishVoiceOverDisclaimer } from "../../utils/handleVoice";
import AxiosRequest from "../../utils/axios";
import { playVoiceOver, stopAudio, } from "../../utils/handleVoiceAndLang";
import DotsLoader from "../Loader/DotsLoader/DotsLoader";
import { handleProgress, isNewUI } from "../../utils/handleProgress";
import ProposalVerification from "../POSV_New_Ui/ProposalVerification/ProposalVerification";
import { SpeakerContext } from "../../context/SpeakerContext";
import BrowserWarning from "../POSV_New_Ui/BrowserWarning/BrowserWarning";
import BlockedJourneyNew from "../POSV_New_Ui/BlockedJourneyNew/BlockedJourneyNew";
import {
    getConfigFromParamStore,
    getConfigFromStroage,
  } from "../../utils/getUrlsFromAws";
import { getOTPDeclarationIds, storeObjectDataInStorage } from "../../utils/handleData";
import { CAPS_Y, PHONE_BANKING_SOURCE_CHANNEL, TELEBINDING_SOURCE_CHANNEL } from "../../utils/constants";
import { hideHeader } from "../../utils/helperFunctions";
import { UAParser } from 'ua-parser-js';


const axios = new AxiosRequest().getClient()

class Verify extends Component {
    constructor() {
        super();
        console.log('otp');
        this.state = {
            txnId: undefined,
            verificationError: false,
            errorMsg: undefined,
            languageSelect: false,
            LanguageSelected: undefined,
            displayLanguage: false,
            category: "",
            validBrowser: validBrowser(),
            showIntroPage: false,
            apiResponse: {},
            productName: "",
            proposerFirstname: "",
            isUlipPlancode: "",
            simplifiedJourney: '',
            deviceInfo: getDeviceBrowserInfo(),
            loading: false,
            showAllLangs: false,
            DisplayUi: true,
            loadingText: "Verifying Link...",
        };
    }

    changeLanguage = (e) => {
        stopVoiceOver();
        const ln = e;
        console.log(e);
        if (ln == "hin" || ln == "eng") {
            i18n.changeLanguage(ln);
        }
        else {
            i18n.changeLanguage("eng");
        }
        localStorage.setItem("LanguageSelected", ln);
        const { category, journeyBy, showNewUi } = this.state;
        this.setState({ LanguageSelected: e }, () => {
            if (journeyBy == "P") {
                if (showNewUi === 'Y') {
                    const { handlebackBtnDisplay } = this.context
                    handlebackBtnDisplay(true)
                    this.setState({ showIntroPage: true })
                }
                // this.props.history.push("/generate_otp");
            } else {
                if (showNewUi === 'Y') {
                    const { handlebackBtnDisplay } = this.context
                    handlebackBtnDisplay(true)
                    this.setState({ showIntroPage: true })
                } else {
                    this.goToPage(category);
                }
            }
        });
    };

    handleValidBrowser = () => {
        if (getDevice() === "mobile") {
            {
                isIOSDevice() ? window.open(iosUrl, "_blank")
                    : window.open(androidUrl, "_blank")
            }
        } else {
            window.open(desktopUrl, "_blank")
        }
    }


    componentWillMount() {
        localStorage.clear();
        const { handleDisplayOfElements } = this.context        
        handleDisplayOfElements('isNewHeader', false);
        sessionStorage.removeItem("isTelebinding");
        sessionStorage.removeItem("isPhoneBanking");
        // stopVoiceOver();
        // this.setState({ showIntroPage: false, })
        handleProgress(0)
        this.props.showLoader(true);
        this.setState({ loading: true });
        getConfigFromParamStore()
            .then((res) => {
                // const { url, body } = getApiData("verifyUser");
                // console.log("URL & BODY : ", { url, body });
                this.props.showLoader(false);
                this.setState({ loading: false });
                this.startLoad();
            })
            .catch((err) => {
                console.log("Error in getting config - ", err);
                this.props.showLoader(false);
                this.setState({
                    loading: false,
                    verificationError: true,
                    languageSelect: false,
                    errorMsg: "Failed to get config",
                });
            });
        // this.startLoad();
        // console.log(this.state.validBrowser);
    }



    handleVerificationBtn = () => {
        playVoiceOver('verify-aud', 'langselect')

        // if (this.state.isUlipPlancode === "Y") {
        //     handleVoice(handleVoiceOverLang("eng"), englishVoiceOverDisclaimer.ulipText)
        //     handleVoice(handleVoiceOverLang("hin"), hindiVoiceOverDisclaimer.ulipText)
        // } else {
        //     handleVoice(handleVoiceOverLang("eng"), englishVoiceOverDisclaimer.nonUlip)
        //     handleVoice(handleVoiceOverLang("hin"), hindiVoiceOverDisclaimer.nonUlip)
        // }

        if(!isNewUI()){
            const { handleAudioIconDisplay } = this.context
            handleAudioIconDisplay(false)
        }

        this.handeApiResponse()
        this.setState({ showIntroPage: false, })
        // this.startLoad();
        console.log(this.state.validBrowser);
    }

    startLoad = () => {
        const txnId = this.props.history.location.search.split("=")[1];
        this.setState({ languageSelect: true, });
        this.verifyUser(txnId);
    };



    handeApiResponse = () => {

        const {
            posvRefNumber,
            isLinkValid,
            category,
            planCode,
            chanelName: channelName,
            vernacularStatus,
            productName,
            journeyBy,
            proposermobNum,
            source,
            isNps,
            proposerFirstname,
            isUlipPlancode,
            hybridPosv,
            physicalJourneyEnabled,
            consentDeclarationText,
            simplifiedJourney,
            policyNumber,
            twoStep,
            videoSuppression,
            showNewUi,
            allinsurerDetails,
            submissionRestricted,
            isWipClubbed,
            isPanAadharLinked,
            needClientConsent,
            vPosvNewDeclaration,
            goGreen,
            fdModelWaitTime,
            insurerDob,
            isDhuMedical,
            proposerDob,
            cis,
            showBiDetails,
            supressVoiceOver,
            lPosv,
            otpOnlyPosv,
            isPanLinked,
            seniorCitizen,
            basbaConsent,
            upfrontPaymentConsent,
            isVposvS3Upload,
            isTmbChannel,
            showNewGoGreenUi,
            tinyFaceDetectionModel,
        } = this.state.apiResponse.data.response.payload;

        localStorage.setItem("tinyFaceDetectionModel", tinyFaceDetectionModel)
        localStorage.setItem("isTmbChannel", isTmbChannel)
        localStorage.setItem("showNewGoGreenUi", showNewGoGreenUi)
        localStorage.setItem("basbaConsent", basbaConsent)
        localStorage.setItem("upfrontPaymentConsent", upfrontPaymentConsent)
        localStorage.setItem("seniorCitizen", seniorCitizen)
        localStorage.setItem("lPosv", lPosv ? lPosv : false)
        localStorage.setItem("isPanLinked", isPanLinked)
        localStorage.setItem("otpOnlyPosv", otpOnlyPosv)
        localStorage.setItem("isDhuMedical", isDhuMedical)
        localStorage.setItem("insurerDob", insurerDob)
        localStorage.setItem("proposerDob", proposerDob)
        localStorage.setItem("fdModelWaitTime", fdModelWaitTime)
        localStorage.setItem("cis",cis?.toLowerCase())
        localStorage.setItem("showBiDetails",showBiDetails)
        localStorage.setItem("isVposvS3Upload",isVposvS3Upload)
        if (showNewUi == "Y") {
            if (!validBrowserForNewUi()) {
                this.setState({ DisplayUi: false })
            }
            // if (getDevice() == "desktop" || !validBrowserForNewUi()) {
            //     this.setState({ DisplayUi: false })
            // }
        }

        const { txnId } = this.state

        let enableHposv = ""
        if (hybridPosv == "Y") {
            if (videoSuppression == "Y") {
                enableHposv = "N"
            } else {
                enableHposv = "Y"
            }
        } else {
            enableHposv = "N"
        }

        const { handleAudioIconDisplay } = this.context
        if (isLinkValid && vernacularStatus === "Y") {
            this.props.showLoader(false);
            if(showNewUi==='Y'){
                handleAudioIconDisplay(true)
            }
            localStorage.setItem("posvRefNumber", posvRefNumber);
            localStorage.setItem("planCode", planCode);
            localStorage.setItem("isPanAadharLinked", isPanAadharLinked);
            localStorage.setItem("customerConsentAfyp", needClientConsent);
            this.setState({ displayLanguage: true, category, journeyBy });
            localStorage.setItem("category", category);
            localStorage.setItem("isUlipPlancode", isUlipPlancode);
            localStorage.setItem("journeyBy", journeyBy);
            localStorage.setItem("channelName", channelName.toLowerCase());
            localStorage.setItem("proposermobNum", proposermobNum);
            localStorage.setItem("policyNumber", policyNumber);
            localStorage.setItem("productName", productName);
            localStorage.setItem("source", source);
            localStorage.setItem("sessionId", this.getDateTmeStamp());
            localStorage.setItem("isNps", isNps);
            localStorage.setItem("proposerFirstname", proposerFirstname);
            localStorage.setItem("isVideoPosv", enableHposv)
            // localStorage.setItem("videoSuppression", videoSuppression)
            localStorage.setItem("physicalJourneyEnabled", physicalJourneyEnabled?.toLowerCase())
            localStorage.setItem("consentDeclarationText", JSON.stringify(consentDeclarationText))
            localStorage.setItem("simplifiedJourney", simplifiedJourney?.toLowerCase())
            localStorage.setItem("allinsurerDetails", JSON.stringify(allinsurerDetails))
            sessionStorage.setItem('txnId', txnId)
            localStorage.setItem("twoStep", twoStep);
            localStorage.setItem("isWipClubbed", isWipClubbed);
            localStorage.setItem("showNewUI", showNewUi);
            localStorage.setItem("vPosvNewDeclaration", vPosvNewDeclaration);
            localStorage.setItem("showGoGreenSection", goGreen);
            // localStorage.setItem("showNewUI", "Y");
            if (isWipClubbed == "Y" && journeyBy == "P") {
                i18n.changeLanguage("eng");
                if(channelName.toLowerCase() !== "by") {
                    this.setState({ showIntroPage: true })
                } else {
                    this.props.history.push("/generate_otp");
                }
            }
            const regex = /PosvTokenId=(.[^;]*)/gi;

            const posvTokenId = regex.exec(document.cookie);

            if (posvTokenId && posvRefNumber !== posvTokenId[1]) {
                this.sendCookie(posvRefNumber, posvTokenId[1]);
            }

            document.cookie = `PosvTokenId=${posvRefNumber}; max-age=31536000;secure;`;
            return;
        }
        if (isLinkValid && vernacularStatus === "N") {
            localStorage.setItem("posvRefNumber", posvRefNumber);
            localStorage.setItem("isNps", isNps);
            localStorage.setItem("allinsurerDetails", JSON.stringify(allinsurerDetails))
            localStorage.setItem("proposerFirstname", proposerFirstname);
            localStorage.setItem("productName", productName);
            localStorage.setItem("planCode", planCode);
            localStorage.setItem("isUlipPlancode", isUlipPlancode);
            localStorage.setItem("category", category);
            // localStorage.setItem("videoSuppression", videoSuppression)
            localStorage.setItem("journeyBy", journeyBy);
            localStorage.setItem("channelName", channelName.toLowerCase());
            localStorage.setItem("proposermobNum", proposermobNum);
            localStorage.setItem("policyNumber", policyNumber);
            localStorage.setItem("twoStep", twoStep);
            localStorage.setItem("isPanAadharLinked", isPanAadharLinked);
            localStorage.setItem("customerConsentAfyp", needClientConsent);
            localStorage.setItem("isWipClubbed", isWipClubbed);
            const ln = "eng";
            localStorage.setItem("LanguageSelected", ln);
            localStorage.setItem("source", source);
            localStorage.setItem("sessionId", this.getDateTmeStamp());
            localStorage.setItem("isVideoPosv", enableHposv)
            localStorage.setItem("physicalJourneyEnabled", physicalJourneyEnabled?.toLowerCase())
            localStorage.setItem("consentDeclarationText", JSON.stringify(consentDeclarationText))
            localStorage.setItem("simplifiedJourney", simplifiedJourney?.toLowerCase())
            sessionStorage.setItem('txnId', txnId)
            localStorage.setItem("showNewUI", showNewUi);
            localStorage.setItem("vPosvNewDeclaration", vPosvNewDeclaration);
            localStorage.setItem("showGoGreenSection", goGreen);
            // localStorage.setItem("showNewUI", "Y");
            i18n.changeLanguage("eng");

            const regex = /PosvTokenId=(.[^;]*)/gi;

            const posvTokenId = regex.exec(document.cookie);

            if (posvTokenId && posvRefNumber !== posvTokenId[1]) {
                this.sendCookie(posvRefNumber, posvTokenId[1]);
            }

            document.cookie = `PosvTokenId=${posvRefNumber}; max-age=31536000`;
            if (isWipClubbed == "Y" && journeyBy == "P") {
                i18n.changeLanguage("eng");
                this.setState({ showIntroPage: true })
                this.props.history.push("/generate_otp");
            }
            if (journeyBy == "P") {
                this.props.history.push("/generate_otp");
            } else {
                if (showNewUi === 'Y') {
                    const { handlebackBtnDisplay } = this.context
                    handlebackBtnDisplay(true)
                    handleAudioIconDisplay(true)
                    this.setState({ showIntroPage: true })
                } else {
                    this.goToPage(category);
                }
            }
        }

    }

    verifyUser = async (txnId) => {
        this.props.showLoader(true);
        this.setState({ loading: true, loadingText: "Verifying Link..." });
        const deviceData = UAParser(navigator.userAgent)
        const { client, device } = this.state.deviceInfo
        console.log({ deviceData, old: this.state.deviceInfo })
        const { url, body } = getApiData("verifyUser");
        body.request.payload.posvRefNumber = txnId;
        body.request.payload.iosStatus = isIOSDevice() ? true : false;
        body.request.payload.linkOpenDateTime = this.getDateTmeStamp();
        body.request.payload.browserName = deviceData?.browser?.name ?? client?.name
        body.request.payload.browserVersion = deviceData?.browser?.version ?? client?.version
        body.request.payload.deviceBrand = deviceData?.device?.vendor ?? device?.brand
        body.request.payload.deviceModel = deviceData?.device?.model ?? device?.model
        body.request.payload.deviceType = deviceData?.device?.type ?? device?.type


        try {
            if (!window.navigator.onLine) {
                throw "Please check you network connection";
            }
            const response = await axios.post(url, body);
            console.log('res', response);

            if (response.data && response.data.errorMessage) {
                throw response.data.errorMessage;
            }

            const {
                businessMsg,
                isLinkValid,
                category,
                planCode,
                chanelName: channelName,
                vernacularStatus,
                productName,
                journeyBy,
                proposerFirstname,
                isNps,
                isUlipPlancode,
                hybridPosv,
                physicalJourneyEnabled,
                simplifiedJourney,
                twoStep,
                videoSuppression,
                showNewUi,
                submissionRestricted,
                supressVoiceOver,
                lPosv,
                posvRefNumber,
                sourceChannel,
                isPolicyInactive,
                tinyFaceDetectionModel,
                isNonCasaCase
            } = response.data.response.payload;
            localStorage.setItem("tinyFaceDetectionModel", tinyFaceDetectionModel)
            const { loadFaceDetectionModel } = this.context
            if(tinyFaceDetectionModel !== null || tinyFaceDetectionModel !== undefined) {
                loadFaceDetectionModel()
            }
            if (sourceChannel === TELEBINDING_SOURCE_CHANNEL || sourceChannel === PHONE_BANKING_SOURCE_CHANNEL) {
                const { handleDisplayOfElements } = this.context
                if(sourceChannel === PHONE_BANKING_SOURCE_CHANNEL) {
                    sessionStorage.setItem("isPhoneBanking", CAPS_Y)
                }
                sessionStorage.setItem("isTelebinding", CAPS_Y);
                sessionStorage.setItem("proposerFirstname", proposerFirstname);
                sessionStorage.setItem("posvRefNumber", posvRefNumber);
                sessionStorage.setItem("txnId", txnId)
                sessionStorage.setItem("isNonCasaCase", isNonCasaCase);
                localStorage.setItem("LanguageSelected", "eng");
                handleDisplayOfElements('isNewHeader', true);
                i18n.changeLanguage("eng");
                storeObjectDataInStorage(true, response.data.response.payload)
                const declarationResponse = await this.getDeclarationFromAPI();
                const declarations = declarationResponse.data.response.payload.declarations
                sessionStorage.setItem("declarations", JSON.stringify(declarations))
                this.props.history.push("/otp-verification");
                return;
            }

            if (isPolicyInactive === true) {
                localStorage.setItem('showNewUI', 'Y')
                if (businessMsg) {
                    sessionStorage.setItem("expiredBusinessMsg", businessMsg);
                }
                this.setState({
                    businessMsg: businessMsg || "Your link has been expired, kindly connect with seller"
                });

                this.props.history.push('/blocked_journey?s=pi');
                return;
            }

            let enableHposv = ""
            if (hybridPosv == "Y") {
                if (videoSuppression == "Y") {
                    enableHposv = "N"
                } else {
                    enableHposv = "Y"
                }
            } else {
                enableHposv = "N"
            }
            this.setState({ apiResponse: response, productName, proposerFirstname, businessMsg, submissionRestricted, isNps, videoSuppression, twoStep, isUlipPlancode, physicalJourneyEnabled, showNewUi, supressVoiceOver, lPosv })

            if (!planCode || !channelName) {
                throw businessMsg;
            }

            if (response.data.response.msgInfo.msgCode == 200 && isLinkValid) {
                const { handleAudioIconDisplay, handleHeaderDisplay, handleDisplayOfElements } = this.context
                if (!showNewUi || showNewUi === 'N') {
                    handleAudioIconDisplay(false)
                    handleHeaderDisplay(true)
                    handleDisplayOfElements('showFooter',true)
                    setTimeout(()=>{
                        const event = new CustomEvent("gotChannel", { detail: { channelName } });
                        document.dispatchEvent(event);
                    },40)
                }
                this.setState({ displayLanguage: true, category, journeyBy, showIntroPage: true, isVideoPosv: enableHposv, simplifiedJourney, txnId, supressVoiceOver, lPosv });
                // this.handeApiResponse()
                if (showNewUi === 'Y') {
                     handleAudioIconDisplay(true)
                     handleDisplayOfElements('showFooter',false)
                    this.handleVerificationBtn()
                }
                return
            }
            if (isLinkValid && vernacularStatus === "N") {
               
            } else {
                throw businessMsg;
            }
        } catch (errorMsg) {
            this.props.showLoader(false);
            let errMsg = ''
            if (typeof errorMsg == "object") {
                errMsg = 'Something went wrong!'

            } else {
                errMsg = errorMsg
            }
            this.setState({
                verificationError: true,
                languageSelect: false,
                errorMsg: errMsg,
            });
        } finally {
            // handleProgress(20)
            this.props.showLoader(false);
            this.setState({ loading: false })
        }
    };

    getDateTmeStamp = () => {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        let time =
            today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        let todayStamp = dd + ":" + mm + ":" + yyyy + " " + time;

        return todayStamp;
    };

    sendCookie = async (posvRefNumber, posvTokenId) => {
        const { url, body } = getApiData("saveCookiesDrop");
        body.request.payload.posvRefNumber = posvRefNumber;
        body.request.payload.posvTokenId = posvTokenId;
        try {
            await axios.post(url, body);
        } catch (e) { }
    };

    goToPage = async (category) => {
        const { handlebackBtnDisplay } = this.context
        handlebackBtnDisplay(false)
        category = category.toLowerCase();
        let url = "";
        const { isVideoPosv, simplifiedJourney } = this.state
        this.props.showLoader(true);
        this.setState({ loading: true, loadingText: this.props.t("Please wait") });
        try {
            const response = await this.getDeclarationFromAPI();
            const declarations = response.data.response.payload.declarations
            sessionStorage.setItem("declarations", JSON.stringify(declarations))
            switch (category) {
                case "selfie":
                    this.props.showLoader(false);
                    url = `/${category}`;
                    break;
                case "selfie_live":
                    this.props.showLoader(false);
                    url = `/selfie`;
                    break;
                case "generate_otp":
                    this.props.showLoader(false);
                    url = `/generate_otp`;
                    break;
                case "pdf":
                    this.props.showLoader(false);
                    url = `/pdf`;
                    break;
                case "clubbed_otp_question":
                    this.props.showLoader(false);
                    url = `/policy-confirmation`;
                    break;
                default:
                    if (simplifiedJourney?.toLocaleLowerCase() == 'y') {
                        if (isVideoPosv === "Y") {
                            url = `/video-verification`;
                        } else {
                            url = `/customer_feedback`;
                        }
                    }
                    else {
                        if (isVideoPosv === "Y") {
                            url = `/video-verification?page=${category}`;
                        } else {
                            url = `/customer_feedback?page=${category}`;
                        }
                    }
    
            }
            this.props.history.push(url);
        } catch (error) {
            console.log("Error in getting declarations", error);
            this.setState({verificationError: true, errorMsg: "Failed to get declarations", showIntroPage: false})
        } finally {
            this.props.showLoader(false);
            this.setState({ loading: false });
        }

    };

    handleSelectAll = () => {
        this.setState({ showAllLangs: true })
    }

    getDeclarationFromAPI = () => {
        const {url, body} = getApiData("getDbStatusEndPoint");
        let lang = localStorage.getItem("LanguageSelected")
        if (lang === "eng") {
            lang = "English";
          }
          if (lang === "hin") {
            lang = "Hindi";
          }
      
        body.request.payload.declarationids = getOTPDeclarationIds();
        body.request.payload.lang = lang;
        
        console.log('body', body)
        return axios.post(url, body)
    };

    render() {
        const { proposerFirstname, loading, isWipClubbed, showAllLangs, isNps, showIntroPage, showNewUi, DisplayUi, businessMsg, submissionRestricted, supressVoiceOver, lPosv } = this.state
        if (!DisplayUi) {
            return (
                <div className="verify_user">
                    <div>
                        <div className="BrowserButtonContainer">
                            <ErrorOutlineIcon className="icon" />
                            <h3>Browser not supported</h3>
                            <p>Please Use Chrome to go through the journey, you can download it from here./कृपया यात्रा के दौरान क्रोम का उपयोग करें, आप इसे यहां से डाउनलोड कर सकते हैं</p>
                            <span className="btn-section">
                                <button className="btn" onClick={this.handleValidBrowser}>DOWNLOAD</button>
                            </span>
                        </div>

                    </div>
                </div>
            )
        }

        return (
            <>
                {showNewUi !== 'Y' && showIntroPage && <Introduction handleVerificationBtn={this.handleVerificationBtn} proposerFirstname={this.state.proposerFirstname} journeyBy={this.state.journeyBy} twoStep={this.state.twoStep} isNps={this.state.isNps} isVideoPosv={this.state.isVideoPosv} productName={this.state.productName} />}
                {/* {this.state.showIntroPage ? (<Introduction handleVerificationBtn={this.handleVerificationBtn} />)
          : ( */}
                {/* {DisplayUi ? */}
                <> {submissionRestricted == "Y" ? <BlockedJourneyNew businessMsgVerify={businessMsg} submissionRestrictedVerify={submissionRestricted} /> :
                    <> {showNewUi == 'Y' && showIntroPage && <ProposalVerification goToPage={this.goToPage} lPosv={lPosv ? lPosv : false} />}
                        <audio className="aud-el-hide" id='verify-aud' ></audio>
                        {loading && <DotsLoader msg={this.state.loadingText} />}
                        <div className="cstm-wrap">
                            {this.state.validBrowser ?
                                <div className="verify_user">
                                    {!this.state.verificationError ? (
                                        !isWipClubbed &&
                                        <>
                                            {(!showAllLangs && showNewUi == 'Y' && !showIntroPage) && <div className=" cstm-app-wrapper userGreetingWrap">
                                                <div className="userName">
                                                    Hi {proposerFirstname}
                                                </div>
                                                <p>Welcome to </p>
                                                <p>Axis Max Life Insurance</p>
                                                <p> Proposal Verification</p>
                                            </div>}
                                            {this.state.languageSelect && this.state.displayLanguage && !this.state.showIntroPage ? (

                                                // <div>

                                                <LanguageSelect selectLanguage={this.changeLanguage} simplifiedJourney={this.state.simplifiedJourney?.toLocaleLowerCase()} showAllLangs={showAllLangs} setShowAllLangs={this.handleSelectAll} supressVoiceOver={supressVoiceOver} />
                                                // </div>

                                            ) : null}
                                        </>
                                        // <div>
                                        //     <div>
                                        //         {
                                        //             this.state.showIntroPage ? <Introduction handleVerificationBtn={this.handleVerificationBtn} proposerFirstname={this.state.proposerFirstname} journeyBy={this.state.journeyBy} twoStep={this.state.twoStep} isNps={this.state.isNps} isVideoPosv={this.state.isVideoPosv} productName={this.state.productName} /> : null
                                        //         }
                                        //     </div>

                                        // {this.state.languageSelect && this.state.displayLanguage && !this.state.showIntroPage ? (

                                        //     <div>

                                        //         <LanguageSelect selectLanguage={this.changeLanguage} simplifiedJourney={this.state.simplifiedJourney?.toLocaleLowerCase()} />
                                        //     </div>

                                        // ) : null}
                                        // </div>
                                    ) : null}
                                    {this.state.verificationError ? (
                                        <Error errorMsg={this.props.t(`${this.state.errorMsg}`)} buttonText={"Retry"} />
                                    ) : null}
                                </div> :
                                <div className="verify_user">
                                    <div>
                                        <div className="BrowserButtonContainer">
                                            <ErrorOutlineIcon className="icon" />
                                            <h3>Browser not supported</h3>
                                            <p>Please Use Chrome to go through the journey, you can download it from here./कृपया यात्रा के दौरान क्रोम का उपयोग करें, आप इसे यहां से डाउनलोड कर सकते हैं</p>
                                            <span className="btn-section">
                                                <button className="btn" onClick={this.handleValidBrowser}>DOWNLOAD</button>
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            }
                        </div>
                        {/* )} */}
                    </>}</>
                {/* // :
                    // <BrowserWarning />} */}
            </>
        );
    }
}

export default compose(
    withRouter,
    connect(null, { showLoader }),
    withTranslation()
)(Verify);

Verify.contextType = SpeakerContext
